/* eslint-disable quote-props */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { Cookies } from 'react-cookie';

export const cookie = new Cookies();

export const getItemFromStorage = name => JSON.parse(localStorage.getItem(name));

export const getToken = () => {
  const token = cookie.get('__session');
  const tokenString = token ? token.toString() : '';
  return tokenString;
};

export const domainAPI = process.env.REACT_APP_API_HOST;

export const getUri = () =>
  process.env.NODE_ENV !== 'production' && process.env.REACT_APP_API_BASE_URL
    ? process.env.REACT_APP_API_BASE_URL
    : `${domainAPI}/api/v2`;

export const getOldUri = () =>
  process.env.NODE_ENV !== 'production' && process.env.REACT_APP_API_BASE_OLD_URL
    ? process.env.REACT_APP_API_BASE_OLD_URL
    : `${domainAPI}/de-CH/api`;

export const headers = {
  'Content-Type': 'application/json',
  content: 'application/json',
  timeout: 5000,
  accept: 'application/json',
};

export const userApi = axios.create({
  baseURL: getUri(),
  headers: { ...headers },
});

export const oldUserApi = axios.create({
  baseURL: getOldUri(),
  headers: { ...headers, content: 'application/x-www-form-urlencoded' },
});

export const saveToStorage = (name, object) => {
  localStorage.setItem(name, JSON.stringify(object));
};

export const Base64ToString = (buffer, stringType = 'ascii') =>
  Buffer.from(buffer.toString(), 'base64').toString(stringType);

export const StringToBase64 = string => Buffer.from(string).toString('base64');

export const obtainClerkToken = (identityId, otpToken) => {
  return oldUserApi.post(
    `/clerk/${identityId}/token_sign_in`,
    {},
    { headers: { 'Content-Type': 'application/json', 'X-Otp-Token': otpToken } },
  );
};
